/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Reposition_To_TopInputs */

const en_subtitle_export_reposition_to_top = /** @type {(inputs: Subtitle_Export_Reposition_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reposition to Top`)
};

const fr_subtitle_export_reposition_to_top = /** @type {(inputs: Subtitle_Export_Reposition_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repositionner en haut`)
};

const de_subtitle_export_reposition_to_top = /** @type {(inputs: Subtitle_Export_Reposition_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu positionieren an die Spitze`)
};

const it_subtitle_export_reposition_to_top = /** @type {(inputs: Subtitle_Export_Reposition_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riposiziona in alto`)
};

const ru_subtitle_export_reposition_to_top = /** @type {(inputs: Subtitle_Export_Reposition_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместить наверх`)
};

const es_subtitle_export_reposition_to_top = /** @type {(inputs: Subtitle_Export_Reposition_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reposicionar en la parte superior`)
};

const zh_cn2_subtitle_export_reposition_to_top = /** @type {(inputs: Subtitle_Export_Reposition_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回顶部`)
};

const ja_subtitle_export_reposition_to_top = /** @type {(inputs: Subtitle_Export_Reposition_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上部に再配置`)
};

const hi_subtitle_export_reposition_to_top = /** @type {(inputs: Subtitle_Export_Reposition_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्ष पर पुनः स्थान प्राप्त करें`)
};

const pt_pt2_subtitle_export_reposition_to_top = /** @type {(inputs: Subtitle_Export_Reposition_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reposicionar para o topo`)
};

/**
* | output |
* | --- |
* | "Reposition to Top" |
*
* @param {Subtitle_Export_Reposition_To_TopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_reposition_to_top = /** @type {((inputs?: Subtitle_Export_Reposition_To_TopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Reposition_To_TopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_reposition_to_top(inputs)
	if (locale === "de") return de_subtitle_export_reposition_to_top(inputs)
	if (locale === "it") return it_subtitle_export_reposition_to_top(inputs)
	if (locale === "ru") return ru_subtitle_export_reposition_to_top(inputs)
	if (locale === "es") return es_subtitle_export_reposition_to_top(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_reposition_to_top(inputs)
	if (locale === "ja") return ja_subtitle_export_reposition_to_top(inputs)
	if (locale === "hi") return hi_subtitle_export_reposition_to_top(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_reposition_to_top(inputs)
	return en_subtitle_export_reposition_to_top(inputs)
});